import { Component, OnInit } from "@angular/core";
import { UserService } from "src/app/services/user.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
	selector: "app-main",
	templateUrl: "./main.component.html",
	styleUrls: ["./main.component.scss"],
})
export class MainComponent implements OnInit {
	page
	object
	id
	idProfessional
	user

	nome;
	constructor(
		private userService: UserService,
		private route: ActivatedRoute,
		private router: Router
	) {}

	ngOnInit() {
		this.nome = this.userService.getName();
		this.idProfessional = this.userService.getId();
		this.route.params.subscribe((params) => {
			this.page = params["page"];
			this.object = params["object"];
			this.id = params["id"];
		});

		this.userService.getPerfil().subscribe(
			(res) => {
				this.user = res['profissional']
			},
			(err) => {}
		);
	}

	sair() {
		this.userService.clear();
		this.router.navigate(["/"]);
	}
}
